module.exports = __webpack_public_path__ + "static/media/w_45.d242c550.png";